'use strict';

// export this package's api
module.exports = require('./Pagination');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.6.9@rc-pagination/lib/index.js
 ** module id = 422
 ** module chunks = 0
 **/